import { render, staticRenderFns } from "./ReservePolicyAgreePopup.vue?vue&type=template&id=779cbed9&scoped=true&"
import script from "./ReservePolicyAgreePopup.vue?vue&type=script&lang=js&"
export * from "./ReservePolicyAgreePopup.vue?vue&type=script&lang=js&"
import style0 from "./ReservePolicyAgreePopup.vue?vue&type=style&index=0&id=779cbed9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779cbed9",
  null
  
)

export default component.exports